<template>
  <div>
    <h2
      v-if="obData.catalogSectionList && obData.catalogSectionList.messages"
      class="def-header-2 container"
    >
      {{ obData.catalogSectionList.messages.title }}
    </h2>
    <!--filter-->
    <form ref="pageBlogFilter" action="javascript: void(0)">
      <PerfectScrollbar>
        <input
          v-for="item in obData.catalogSmartFilter.hidden"
          type="hidden"
          :name="item.name"
          :value="item.value"
        />
        <div v-for="(item, i) in obData.catalogSmartFilter.ITEMS" :key="i" class="page-blog-filter">
          <label
            v-for="(element, k) in item.VALUES"
            :key="k"
            class="page-blog-filter__item"
            :class="{ 'page-blog-filter__item_atcive': element.CHECKED }"
          >
            <input
              type="checkbox"
              :name="element.CONTROL_NAME"
              value="Y"
              :checked="element.CHECKED"
              @change="changeFilter()"
            />
            <span>#{{ element.VALUE }}</span>
          </label>
        </div>
      </PerfectScrollbar>
    </form>
    <div class="container">
      <div class="page-blog__items">
        <JewelryCard
          v-for="item in obData.catalogSectionList.items"
          :key="item.id"
          :result="item"
        />
      </div>
      <Pagination
        :result="obData.catalogSectionList.pagination"
        @change="getPage"
        @addMore="addMore"
      />
    </div>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import Pagination from '@components/bootstrap/Pagination.vue';
import JewelryCard from '@components/card/JewelryCard/JewelryCard.vue';
import { mapMutations } from 'vuex';

export default {
  name: 'Blog',
  components: {
    JewelryCard,
    Pagination,
    PerfectScrollbar,
  },
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      obData: this.result,
    };
  },
  methods: {
    ...mapMutations({
      loaderStart: 'global/loaderStart',
      loaderStop: 'global/loaderStop',
    }),
    /**
     * Тут происходит склеивание данных успешного ответа Ajax запроса
     */
    compareResponse(response) {
      const data = response.data.catalogSectionList;

      if (this.debug) {
        console.log('ajaxResponse', response);
      }

      for (const key in data.items) {
        this.obData.catalogSectionList.items.push(data.items[key]);
      }

      this.obData.catalogSectionList.pagination = data.pagination;
    },
    /**
     * Имитация перехода на нужную страницу
     */
    replaceResponse(response) {
      this.obData = response.data;
    },
    /**
     * Метод по которому происходит Ajax загрузка данных (добавление)
     */
    async addMore() {
      if (
        this.obData.catalogSectionList.pagination.pageCount >
        this.obData.catalogSectionList.pagination.pageNumber
      ) {
        axios
          .get(window.location.href, {
            params: {
              api: 'y',
              [this.obData.catalogSectionList.pagination.pagingKey]: ++this.obData
                .catalogSectionList.pagination.pageNumber,
            },
          })
          .then(this.compareResponse)
          .catch((error) => {
            console.log(error);
          })
          .then(() => {
            console.log('always executed');
          });
      }
    },
    /**
     * Метод по которому происходит Ajax переход на нужную страницу
     * @param numb
     */
    async getPage(url) {
      try {
        this.loaderStart();

        const response = await axios.get(url, {
          params: {
            api: 'y',
          },
        });

        this.replaceResponse(response);
      } catch (err) {
        console.error(err);
      } finally {
        this.loaderStop();
      }
    },
    createUrl(formData) {
      let url = '?';
      for (const pair of formData.entries()) {
        if (url[url.length - 1] === '&' || url[url.length - 1] === '?') {
          url += `${pair[0]}=${pair[1]}`;
        } else {
          url += `&${pair[0]}=${pair[1]}`;
        }
      }
      return url;
    },
    changeFilter() {
      try {
        const formData = new FormData(this.$refs.pageBlogFilter);
        const url = this.createUrl(formData);

        fetch(url, {
          method: this.obData.catalogSmartFilter.form.method,
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.SEF_SET_FILTER_URL) {
              location.pathname = data.SEF_SET_FILTER_URL;
            } else {
              console.warn(`data.SEF_SET_FILTER_URL is ${data.SEF_SET_FILTER_URL}`);
            }
          });
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss">
.page-blog-filter {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  overflow-x: auto;
  padding-left: 15px;
  padding-bottom: 15px;
  @include point-md {
    margin-bottom: 32px;
    padding: 0 15px 15px;
    justify-content: center;
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    background: rgba(184, 217, 236, 0.4);
    border-radius: 20px;
    font-weight: 500;
    font-size: rem(12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--text-colour-secondary);
    flex-shrink: 0;
    &:not(:last-child) {
      margin-right: 8px;
    }
    &:hover {
      cursor: pointer;
    }
    &_atcive {
      color: #fff;
      background-color: var(--border-colour-primary);
    }
    input {
      display: none;
    }
  }
}
.page-blog {
  margin-bottom: 56px;
  margin-top: 16px;
  @include point-md {
    margin-bottom: 80px;
  }
  &__items {
    display: grid;
    grid-gap: 16px 0;
    @include point-md {
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 24px;
    }
    @include point-md {
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 40px;
    }
  }
  .pagination {
    padding: 40px 0 0;
    @include point-md {
      padding: 56px 0 0;
    }
    @include point-lg {
      padding: 0px;
    }
  }
  .jewelry-card {
    height: auto;
  }
}
</style>
